/**
 * Transform airport
 *
 * @param {Object} airport
 */

import { DEFAULT_COUNTRY } from 'Constants';

export default function transformAirport (airport) {
    let name = airport.name;

    if (airport.iata) {
        name = `${ name } (${ airport.iata })`;
    }
    name = [name];
    if (airport.city) {
        name.push(airport.city);
    }
    if (airport.stateCode) {
        name.push(airport.stateCode);
    }
    if (airport.countryCode && airport.countryCode !== DEFAULT_COUNTRY) {
        name.push(airport.countryCode);
    }

    return name.filter(Boolean).join(', ');
}
